__turbopack_context__.v({
  "green": "ReliablePartnerBadge-module__V953eW__green",
  "lg": "ReliablePartnerBadge-module__V953eW__lg",
  "link": "ReliablePartnerBadge-module__V953eW__link",
  "md": "ReliablePartnerBadge-module__V953eW__md",
  "root": "ReliablePartnerBadge-module__V953eW__root",
  "sm": "ReliablePartnerBadge-module__V953eW__sm",
});
